export const UNAUTHENTICATED = 'unauthenticated';
export const AUTHENTICATED = 'authenticated';
